/**
 * Roles (architecture.md §3.4; doc 07 R-ROLE).
 * Admin = full control · Agent = inbox/handling · Maintainer = Hillman upkeep.
 */
export const ROLES = ["admin", "agent", "maintainer"];
export function isRole(value) {
    return typeof value === "string" && ROLES.includes(value);
}
//# sourceMappingURL=roles.js.map